import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  toggle: {
    width: 52,
    height: 30,
    borderRadius: 26.47,
    justifyContent: 'center',
    paddingHorizontal: 3,
  },
  circle: {
    width: 24,
    height: 24,
    borderRadius: 17.65,
    backgroundColor: colors.white,
    position: 'absolute',
    top: 3,
    left: 0,
  },
});
